module.exports = __webpack_public_path__ + "static/img/9.ff25e64.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/zh/9.png
// module id = T8pQ
// module chunks = 0